import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { customerApi } from '../api/customerApi';

interface ChangePasswordParams {
  password: string;
  customerId: string;
  reason: string;
}

export const useChangePassword = () => {
  const queryClient = useQueryClient();

  const onSuccess = useCallback(
    (_: any, variables: { customerId: string }) => {
      queryClient.invalidateQueries({
        queryKey: ['reset-password', variables.customerId],
      });
    },
    [queryClient]
  );

  const { mutateAsync: changePassword, isPending: isLoading } = useMutation({
    mutationFn: ({ password, customerId, reason }: ChangePasswordParams) =>
      customerApi.changeUserPassword(customerId, password, reason),
    onSuccess,
  });

  return { changePassword, isLoading };
};
